/**
 * A GTM helper to return the page section based on the current route.
 *
 * @returns The page section.
 *
 * @example
 * ```ts
 * const pageSection = usePageSection()
 * console.log(pageSection) // 'search_results'
 * ```
 */

const PAGE_SECTION_MAP: Record<string, string> = {
  'search': 'search_results',
  'c': 'category_products',
  'supplier': 'supplier_products',
  'clinic-chain': 'clinic_chain_products',
}

/**
 * Resolve a GTM page section from a raw route path (locale prefix aware).
 */
export function resolvePageSection(path: string): string {
  const segment = path.replace(/^\/[a-z]{2}\//, '/').split('/')[1] ?? ''
  return PAGE_SECTION_MAP[segment] ?? segment
}

export function usePageSection(): string {
  const route = useRoute()
  return resolvePageSection(route.path)
}
